import POIStep from "@/components/POI/POIStep/POIStep.vue";
import DateInput from "@/components/Common/DateInput/DateInput.vue";
import TimeInput from "@/components/Common/TimeInput/TimeInput.vue";
import PrognoseSlider from "@/components/POI/PrognoseSlider/PrognoseSlider.vue";
import moment from "moment";

export default {
  name: "ExcursionTicker",
  components: { POIStep, DateInput, TimeInput, PrognoseSlider },
  props: ["editedItem", "step", "position", "isOwnedBySubPrincipal"],
  data: function() {
    return {
      editorUrl: "https://cdn.eberl-online.cloud/ckeditor5/ckeditor5.js",
      maxDaysToDisplay: 7,
      notificationTypes: [
        "Auslastung",
        "Wetterlage",
        "Sperrung",
        "Warnung",
        "Allgemeiner Reisehinweis",
        "Anreise / Verkehrslage",
        "Ausflugstipps"
      ],
      newNotificationType: "",
      notificationTypeDialog: false
    };
  },
  methods: {
    toggleNotificationTypeDialog() {
      this.notificationTypeDialog = !this.notificationTypeDialog;
    },
    addNotificationType() {
      this.toggleNotificationTypeDialog();
      const excursionTicker = {
        notificationType: this.newNotificationType,
        title: "",
        description: "",
        currentWorkload: 0,
        prognosis: [],
        validityTime: null,
        validityDate: null
      };
      if (this.containsPrognosis(excursionTicker)) {
        excursionTicker.prognosis = this.getDefaultPrognosis();
      }
      this.editedItem.excursionTickers.push(excursionTicker);
      this.newNotificationType = "";
    },
    removeNotificationType(notificationType) {
      this.editedItem.excursionTickers = this.editedItem.excursionTickers.filter(
        ticker => ticker.notificationType !== notificationType
      );
    },
    changeStep(position) {
      this.$emit("changeStep", position);
    },
    formatDate(date) {
      return date ? moment(date).format("DD.MM.YYYY") : null;
    },
    formatTime(date) {
      return date ? moment(date).format("HH:mm") : null;
    },
    setValidityTime(excursionTicker, value) {
      excursionTicker.validityTime = value;
      this.setValidity(excursionTicker);
    },
    setValidityDate(excursionTicker, value) {
      excursionTicker.validityDate = this.formatDate(value);
      this.setValidity(excursionTicker);
    },
    setValidity(excursionTicker) {
      if (!excursionTicker.validityTime || !excursionTicker.validityDate) {
        excursionTicker.validity = null;
      } else {
        excursionTicker.validity = moment(
          `${excursionTicker.validityDate} ${excursionTicker.validityTime}`,
          "DD.MM.YYYY HH:mm"
        ).toISOString();
      }
    },
    isToday(date) {
      return moment(date).isSame(moment.now(), "day");
    },
    getPrognosisToDisplay(excursionTicker) {
      if (excursionTicker.prognosis.length < this.maxDaysToDisplay) {
        excursionTicker.prognosis = this.getDefaultPrognosis(
          excursionTicker.prognosis
        );
      }
      return excursionTicker.prognosis.slice(
        excursionTicker.prognosis.length - this.maxDaysToDisplay
      );
    },
    getDefaultPrognosis(prognosis = []) {
      const lastDay = moment.utc(
        prognosis[prognosis.length - 1]?.measurementTime
      );
      for (let i = prognosis.length; i < this.maxDaysToDisplay; i++) {
        const date = lastDay.add(1, "days").toISOString();
        prognosis.push({
          measurementTime: date,
          value: 0
        });
      }
      return prognosis;
    },
    containsPrognosis(excursionTicker) {
      return ["Auslastung", "Ausflugstipps"].includes(
        excursionTicker.notificationType
      );
    }
  },
  mounted() {
    this.editedItem.excursionTickers = this.editedItem.excursionTickers.map(
      ticker => ({
        ...ticker,
        validityDate: this.formatDate(ticker.validity),
        validityTime: this.formatTime(ticker.validity),
        prognosis: this.getPrognosisToDisplay(ticker)
      })
    );
  },
  computed: {
    unsetNotificationTypes() {
      const setNotificationTypes = this.editedItem.excursionTickers.map(
        ticker => ticker.notificationType
      );
      return this.notificationTypes.filter(
        type => !setNotificationTypes.includes(type)
      );
    }
  }
};
